import { useCallback } from 'react';
import {
  useActionsContext,
  useInScopeModel,
} from '@cotera/client/v0/actions/framework';
import {
  ResourceSelectionModel,
  ResourceType,
} from './resource-selection.model';

export interface SelectableItem {
  id: string;
  name: string;
  resourceType: ResourceType;
}

export interface ResourceListSelection {
  handleOpenActionMenu: (item: SelectableItem) => void;
  handleFocusItems: (items: SelectableItem[]) => void;
}

export function useResourceListSelection(): ResourceListSelection {
  const selectionModel = useInScopeModel(ResourceSelectionModel);
  const actionsContext = useActionsContext();

  const handleOpenActionMenu = useCallback(
    (item: SelectableItem) => {
      if (selectionModel === null) {
        return;
      }
      if (actionsContext.isInScope(ResourceSelectionModel) === true) {
        actionsContext.removeTargetForType(ResourceSelectionModel);
      }
      selectionModel.setSelections([
        {
          resourceType: item.resourceType,
          resourceId: item.id,
          name: item.name,
        },
      ]);
      actionsContext.targetModel(selectionModel);
    },
    [actionsContext, selectionModel]
  );

  const handleFocusItems = useCallback(
    (items: SelectableItem[]) => {
      if (selectionModel === null) {
        return;
      }
      if (items.length === 0) {
        selectionModel.clearSelections();
        if (actionsContext.isInScope(ResourceSelectionModel) === true) {
          actionsContext.removeTargetForType(ResourceSelectionModel);
        }
        return;
      }

      if (actionsContext.isInScope(ResourceSelectionModel) === true) {
        actionsContext.removeTargetForType(ResourceSelectionModel);
      }
      selectionModel.setSelections(
        items.map((item) => ({
          resourceType: item.resourceType,
          resourceId: item.id,
          name: item.name,
        }))
      );
      actionsContext.targetModel(selectionModel);
    },
    [actionsContext, selectionModel]
  );

  return { handleOpenActionMenu, handleFocusItems };
}
